<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";

    import { WidgetInterface } from "@interfaces/WidgetInterface";

    type T = $$Generic<
        new (...args: any[]) => WidgetInterface & { destroy: () => void }
    >;
    export let widget: T;

    type WidgetParams = ConstructorParameters<typeof widget>;

    type ModifiedWidgetParams = WidgetParams extends [
        infer First,
        ...infer Rest
    ]
        ? First extends { target: Element }
            ? [{ target?: Element } & Omit<First, "target">, ...Rest]
            : WidgetParams
        : WidgetParams;

    export let params: ModifiedWidgetParams;

    let className: string | undefined = undefined;
    export { className as class };

    const dispatch = createEventDispatcher();

    let widgetContainerRef: HTMLDivElement | undefined;

    onMount(() => {
        if (params[0] && typeof params[0] === "object") {
            params[0].target = widgetContainerRef;
        }

        let instance = new widget(...params);

        void (async () => {
            // Wait for init promise. Init method sometimes returns a promise.
            await instance.init();
            dispatch("widgetInit");
        })();

        return () => {
            instance.destroy();
        };
    });
</script>

<div bind:this={widgetContainerRef} class={className} style="display: block;" />
